// import { User, UserManager, WebStorageStateStore } from 'oidc-client'
import { User, UserManager, WebStorageStateStore } from "oidc-client-ts";

export default class AuthService {
  constructor() {
    // let appUri = window.location.origin + window.location.pathname
    // if (appUri.endsWith("/")) {
    //   appUri=appUri.substring(0, appUri.length-1)
    // }
    let appUri = import.meta.env.VITE_APP_AUTH_REDIRECT_URI

    const settings = {
      authority: import.meta.env.VITE_APP_AUTH_AUTHORITY_URL,
      client_id: import.meta.env.VITE_APP_AUTH_CLIENT_ID,
      client_secret: import.meta.env.VITE_APP_AUTH_CLIENT_SECRET,
      redirect_uri: appUri,
      silent_redirect_uri: appUri+"/#/silent-redirect",
      post_logout_redirect_uri: appUri,
      response_type: 'code',
      scope: import.meta.env.VITE_APP_AUTH_SCOPE,
      userStore: new WebStorageStateStore(),
      loadUserInfo: true,
      automaticSilentRenew: true
    }
    this.userManager = new UserManager(settings)
  }

  signInRedirect() {
    const currentUrl = "redirect_uri:" + window.location.origin + window.location.pathname;

    console.log(`Redirect to: ${currentUrl}`);
    return this.userManager.signinRedirect({ url_state: currentUrl });
  }

  signInCallback() {
    return this.userManager.signinCallback()
  }

  renewToken() {
    return this.userManager.signinSilentCallback()
  }

  logout() {
    return this.userManager.signoutRedirect()
  }

  getUser() {
    return this.userManager.getUser()
  }
}